import github_logo from '../../../img/github-logo.png';
import flickr_logo from '../../../img/flickr.png';
import react_logo from '../../../img/react.png';

import FlickrFlow from '../../widgets/flickr/flickrflow';

export default function flickrFlow_story(props) {

    let flickrFlow_es = (<div>Por mucho tiempo busqué la manera ideal de mostrar mi trabajo fotográfico en la web que no fuese
        mostrando un largo y aburrido listado de fotos. Recordé hace un par de años la vieja interfaz CoverFlow de Apple,
        y me dije ¿por qué no mostrar mis fotos en un carrusel que asemejase la experiencia de hojear un álbum de fotos?
        Busqué algún widget que lo hiciese y no encontré nada que me sirviese. Además, hace mucho tiempo que quería
        jugar con la API de Flickr y dado que en ese momento nacía este sitio web, me pareció una oportunidad ideal
        para aprender React y la API de Flickr al mismo tiempo.
    
    
    La primera versión de este widget estuvo funcionando aquí desde 2023. Sin embargo, no era lo ideal. El acceso
    a la API de Flickr no era el ideal y la transformación geométrica de las fotos no era lo que yo deseaba. Por eso,
    decidió rehacer el widget con la transformaciónn completa y el acceso a la API de Flickr de la manera correcta.
    Le pedí ayuda a Claude y la verdad es que no estaba tan lejos del resultado final, pero sí me ayudó a mejorar el código y
    la experiencia de usuario. Tuvimos que crear, además, una utilidad de autenticación en OAuth y un pequeño backend en Node.js.
    Y dado que finalmente logré un widget hermoso, muy parecido a mis sueños, me dije ¿por qué no compartirlo? Así
    el código de este widget se encuentra disponible como producto gratuito 
    <a href="https://github.com/kurakensama/flickrFlow" target='_blank' rel="noreferrer"> en mi repositorio de GitHub.</a></div>);

    let flickrFlow_en = (<div>For a long time I looked for the ideal way to show my photographic work on the web that went beyond
    exposing a long and boring listing of photos. I remembered a couple of years ago the old Apple CoverFlow interface,
    and I said to myself, why not show my photos in a carousel that resembled the experience of leafing through a photo album?
    I looked for some widget that did it and I didn't find anything that would work for me. Also, I've wanted to play with the
    Flickr API for a long time and since this website was born at that moment, it seemed like an ideal opportunity to learn React
    and the Flickr API at the same time.

    The first version of this widget was working here since 2023. However, it wasn't ideal. The access to the Flickr API wasn't
    ideal and the geometric transformation of the photos wasn't what I wanted. So, I decided to remake the widget with the complete
    transformation and the access to the Flickr API in the correct way. I asked Claude for help and the truth is that I wasn't
    that far from the final result, but it did help me to improve the code and the user experience. We had to create, also, an OAuth
    authentication utility and a small backend in Node.js.
    And since I finally achieved a beautiful widget, very close to my dreams, I said to myself, why not share it?
    So the code of this widget is available in my GitHub repository as a free product.</div>);

    let flickrFlow_text = flickrFlow_es;

    switch(props.lang){
        case "en":
            flickrFlow_text = flickrFlow_en;
        default:
            break;
    }   

    return (
        <article className='article' name='flickrFlow_story'>
            <a href='https://github.com/kurakensama/flickrFlow' target='_blank' rel='noreferrer'>
                <img src={github_logo} width="32px" alt="github"/></a>
             <a href='https://www.flickr.com/kurakensama' target='_blank' rel='noreferrer'>
                <img src={flickr_logo} width="32px" alt="flickr"/></a>
                <img src={react_logo} width="32px" alt="react"/>
            <FlickrFlow per_page={150}/>
            <br></br><br></br><br></br>
            <p>{flickrFlow_text}</p>
        </article>);
}